module.exports = __webpack_public_path__ + "img/tick.649a43fa.svg";